import React from 'react'
import { ReportingCycleSubmission } from './item'
import { dialogTypes } from '@/dialogs'

export class ReportingCyclesSubmissions extends React.Component {
  state = {
    editedSubmission: null,
    editedDate: null
  }
  handleDateSelection (date) {
    const updatedSubmission = { ...this.state.editedSubmission }
    updatedSubmission[this.state.editedDate] = date

    this.updateSubmission(updatedSubmission)
    this.setState({ editedSubmission: null, editedDate: null })
  }
  onDateClick (editedSubmission, editedDate) {
    this.setState({ editedSubmission, editedDate }, () => {
      this.props.openDialog({
        dialogType: dialogTypes.submissionDate,
        localize: this.props.localize,
        submission: editedSubmission,
        editedDate,
        onAction: date => this.handleDateSelection(date)
      })
    })
  }
  onToggleActive (submission) {
    const updatedSubmission = { ...submission }
    updatedSubmission.isActive = !submission.isActive
    this.updateSubmission(updatedSubmission)
  }
  updateSubmission (submission) {
    // add reportingCycleId so we can update collision dates easily from reducer
    this.props.update({ ...submission, reportingCycleId: this.props.reportingCycleId })
  }
  render () {
    const { reportingCycleCollisions, reportingCycle, localize, disabled } = this.props
    const submissions = reportingCycle.submissions || []
    return (
      <div className='cicle-wrap'>
        {submissions.map((submission, i) => <ReportingCycleSubmission key={i}
          reportingCycleCollisions={reportingCycleCollisions}
          localize={localize}
          disabled={disabled}
          frequency={reportingCycle.frequency}
          submission={submission}
          onToggleActive={submission => this.onToggleActive(submission)}
          onDateClick={(editedSubmission, editedDate) => this.onDateClick(editedSubmission, editedDate)} />)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportingCycles/submissions/list.js